import React from "react";

import Background from "../../../assets/cafe/cafe-bg-02.png";
import Image from "../../../assets/cafe/cafe-choice-b.png";

import GamePageLayout from "../GamePageLayout";

const CafePage4 = ({ setCurrentPage }) => {
  return (
    <GamePageLayout
      bg={Background}
      img={Image}
      onClickNext={() => setCurrentPage("lunch-1")}
    >
      텀블러는 들고 다니기 무겁고,
      <br />
      관리하기도 귀찮지.
      <br />
      그래도 플라스틱을 덜 쓸 수 있게
      <br />
      1회용 컵 보증금제라도
      <br />
      만들어졌으면 좋겠다.
    </GamePageLayout>
  );
};

export default CafePage4;
